
import { gsap } from 'gsap/dist/gsap';

/**************************************************************
-> Dropdown logic and interactivity
**************************************************************/
export function mobileDropdown() {
  const dropdowns = document.querySelectorAll('.mobile-dropdown')

  if (dropdowns) {

    dropdowns.forEach(dropdown => {
      const arrow = dropdown.querySelector('.arrow')
      const contents = dropdown.querySelector('.dropdown-contents')
      const colourSwitch = dropdown.querySelector('.color-mode-switch')
      let openState = false
      
      contents.addEventListener('click', () => {
        
        if (openState === false) {
          openState = true
          gsap.to(arrow, {rotation: 180, duration: 0.3})
          gsap.to(dropdown, {height: 'auto', duration: 0.3})
        } else {
          openState = false
          gsap.to(arrow, {rotation: 0, duration: 0.3})
          gsap.to(dropdown, {height: '8rem', duration: 0.3})
        }

      })

      colourSwitch.addEventListener('click', () => {
        openState = false
        gsap.to(arrow, {rotation: 0, duration: 0.3})
        gsap.to(dropdown, {height: '8rem', duration: 0.3})
      })
    })

  }
}


// WEBPACK FOOTER //
// ./scripts/components/mobile-dropdown.js